import { Component, Input, OnChanges, inject } from '@angular/core';
import { IConfigDeseada, IFilter, ILuminaria, IQueryParam } from 'modelos/src';
import { ConfigsDeseadasService } from '../../../../../../auxiliares/servicios/http/configs-deseadas.service';

/**
 * Pestaña "Perfil y comandos" del detalle de luminaria: la jerarquía de
 * perfiles, cómo se aplicó el perfil, los comandos manuales y las métricas de
 * downlinks. Antes iban al final de Info y la hacían muy larga.
 */
@Component({
  selector: 'app-detalles-luminaria-perfil',
  templateUrl: './detalles-luminaria-perfil.component.html',
  styleUrl: './detalles-luminaria-perfil.component.scss',
  standalone: false,
})
export class DetallesLuminariaPerfilComponent implements OnChanges {
  private configsDeseadasService = inject(ConfigsDeseadasService);

  @Input() luminaria?: ILuminaria;

  /** Para comparar la config real con la deseada en la cronología. */
  public configDeseada: IConfigDeseada | null = null;
  private idDispositivoPedido?: string;

  private async listarConfigDeseada(): Promise<void> {
    const idDispositivo = this.luminaria?.dispositivo?._id;
    if (idDispositivo === this.idDispositivoPedido) return;
    this.idDispositivoPedido = idDispositivo;
    if (!idDispositivo) {
      this.configDeseada = null;
      return;
    }
    try {
      const filter: IFilter<IConfigDeseada> = {
        idEntidad: idDispositivo,
      } as IFilter<IConfigDeseada>;
      const query: IQueryParam = {
        filter: JSON.stringify(filter),
        sort: '-fechaCreacion',
        limit: 1,
        includeChildren: true,
      };
      const result = await this.configsDeseadasService.getFiltered(query);
      this.configDeseada = result.datos[0] ?? null;
    } catch (error) {
      console.error('Error obteniendo config deseada:', error);
      this.configDeseada = null;
    }
  }

  ngOnChanges(): void {
    void this.listarConfigDeseada();
  }
}
